"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _Loader = _interopRequireDefault(require("../Loader"));

var _utils = require("../../utils");

require("./Button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** To trigger an operation. */
function Button(props) {
  var type = props.type,
      size = props.size,
      pressed = props.pressed,
      children = props.children,
      loading = props.loading,
      disabled = props.disabled,
      className = props.className,
      rest = _objectWithoutProperties(props, ["type", "size", "pressed", "children", "loading", "disabled", "className"]);

  var classButton = (0, _utils.getClassNames)('button', className, _defineProperty({}, "button-".concat(size), size), _defineProperty({}, "button-".concat(type), type), {
    'button-loading': loading
  }, {
    'button-pressed': pressed
  });
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: type,
    disabled: loading ? true : disabled,
    className: classButton
  }, rest), loading ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    negative: type === 'danger'
  }) : children);
}

Button.propTypes = {
  /** Additional CSS ui classes. Can be set to 'primary',
   * 'secondary', 'danger' or omitted (meaning default) */
  type: _propTypes.default.oneOf(_constants.BUTTON_TYPES),

  /** Additional CSS ui class. Can be set to 'small' or omitted (meaning default) */
  size: _propTypes.default.oneOf(_constants.BUTTON_SIZES),

  /** Whether the button is pressed */
  pressed: _propTypes.default.bool,

  /** Whether the button is loaded */
  loading: _propTypes.default.bool,

  /** @ignore */
  disabled: _propTypes.default.bool,

  /** @ignore */
  children: _propTypes.default.node,

  /** @ignore */
  className: _propTypes.default.string
};
Button.defaultProps = {
  type: null,
  size: null,
  pressed: false,
  loading: false,
  disabled: false,
  children: null,
  className: ''
};
var _default = Button;
exports.default = _default;